import { Injectable } from '@angular/core';
import { continuePathQueryParam, tenantSubDomainQueryParam } from '../../constants';
import { AbstractAuthConfigService } from '../abstract-auth-config/abstract-auth-config.service';
import { WindowHelperService } from '@anecdotes/utils';

@Injectable()
export class TenantSubDomainExtractorService {
  static TenantSubdomainVariable = '{{tenant_sub_domain}}';
  static LocationOriginVariable = '{{location_origin}}';
  static TenantRedirectUrlVariable = '{{tenant_redirect_url}}';

  constructor(private windowHelper: WindowHelperService, private appConfig: AbstractAuthConfigService) {}

  getCurrentTenantSubDomain(): string {
    if (this.appConfig.getConfig().auth.crossDomainSignIn) {
      return this.windowHelper.getLocation().host.substring(0, this.windowHelper.getLocation().host.indexOf('.'));
    }

    const params = this.getQueryParamsObject();
    return params[tenantSubDomainQueryParam];
  }

  getTenantUrl(tenantSubDomain: string): string {
    const result = this.appConfig
      .getConfig()
      .auth.tenantRedirectUrlFormat.replace(TenantSubDomainExtractorService.TenantSubdomainVariable, tenantSubDomain)
      .replace(TenantSubDomainExtractorService.LocationOriginVariable, this.windowHelper.getWindow().location.origin);

    return this.replaceQueryParamPatterns(result);
  }

  getTenantSignInUrl(params?: any): string {
    const queryParams = {
      [tenantSubDomainQueryParam]: this.getCurrentTenantSubDomain(),
      ...params,
    };

    if (queryParams[continuePathQueryParam]) {
      const continuePath = queryParams[continuePathQueryParam].replace(/^\/+/g, '');
      queryParams[continuePathQueryParam] = continuePath;
    }

    const queryParamEntries = Object.entries(queryParams).filter(([_, value]) => value);
    const signInUrl = `${this.appConfig.getConfig().generalTenantUrl}/auth/sign-in`;

    if (queryParamEntries.length) {
      return `${signInUrl}?${queryParamEntries.map(([name, value]) => `${name}=${encodeURIComponent(value as string)}`).join('&')}`;
    }

    return signInUrl;
  }

  getCurrentTenantUrl(): string {
    return this.getTenantUrl(this.getCurrentTenantSubDomain());
  }

  private replaceQueryParamPatterns(template: string): string {
    const pattern = /\{\{queryParam\((?<name>\w+)\)\}\}/gm;
    const queryParamsObj = this.getQueryParamsObject();
    const matchesArray = Array.from(template.matchAll(pattern));

    return matchesArray.reduce(
      (result, match) => result.replace(match[0], queryParamsObj[match.groups.name]),
      template
    );
  }

  private getQueryParamsObject(): { [key: string]: string } {
    const search = this.windowHelper.getWindow().location.search?.substring(1);

    if (!search) {
      return {};
    }

    // https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => {
      return key === '' ? value : decodeURIComponent(value);
    });
  }
}
